"use client";

import { configureAmplifyClient } from "@/lib/amplify/client";

configureAmplifyClient();

export default function Providers({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
